<div class="auth-password-refactor-container" fxLayout="column">
  <div class="mat-card-title">{{ 'auth.refactor password.title' | translate | capitalize }}</div>
  <div fxLayout="row" fxLayoutAlign="center">
    <span>{{ 'auth.postResetInstructions' | translate | capitalize }}</span>
  </div>
</div>
